import { useState } from 'react';

// 通用导出按钮：点击后以 loading 态拉取数据并导出 Excel
interface Props {
  label?: string;
  filename: string;
  columns: { header: string; key: string; format?: (row: any) => any }[];
  fetchData: () => Promise<any[]>; // 返回要导出的行
}

export default function ExportButton({ label = '导出 Excel', filename, columns, fetchData }: Props) {
  const [loading, setLoading] = useState(false);
  const onExport = async () => {
    try {
      setLoading(true);
      const rows = await fetchData();
      const mod = await import('../utils/excel');
      mod.exportExcel(filename, columns, rows);
    } catch (e: any) {
      alert('导出失败：' + (e.message || e));
    } finally {
      setLoading(false);
    }
  };
  return (
    <button
      onClick={onExport}
      disabled={loading}
      className="bg-emerald-600 text-white rounded-lg px-3 py-1.5 hover:bg-emerald-700 text-sm disabled:opacity-60"
    >
      {loading ? '导出中…' : '⬇️ ' + label}
    </button>
  );
}
